// extracted by mini-css-extract-plugin
export var header = "_tt-1";
export var maskBottom = "_tt-6";
export var maskMiddle = "_tt-7";
export var maskTop = "_tt-5";
export var root = "_tt-0";
export var scrollDownButton = "_tt-3";
export var scrollDownButtonHidden = "_tt-4";
export var viewport = "_tt-2";